var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCz = function SvgCz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    viewBox: "0 0 900 780"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cz_svg__a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 390,
    r: 390
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7141a",
    d: "M0 0h900v780H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v390H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11457e",
    d: "M450 390 0 0v780z"
  }))));
};
export default SvgCz;